import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS, BUSINESS } from "@/data/site";
import { SectionHeader, Reveal, EASE } from "@/components/motion/Reveal";

const STAR_KEYS = ["one", "two", "three", "four", "five"];
const Stars = () => (
  <span className="flex gap-0.5">
    {STAR_KEYS.map((k) => (
      <Star key={k} size={14} className="fill-gold text-gold" />
    ))}
  </span>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32 bg-ink2/60 overflow-hidden">
    <div className="absolute -left-40 top-20 w-[600px] h-[600px] rounded-full bg-brand/10 blur-[160px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <SectionHeader
        id="reviews"
        eyebrow="Google reviews"
        lines={["Rated 5.0 by", <>Bendigo <span className="text-brand-light">locals.</span></>]}
        right={
          <span className="inline-flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-full px-4 py-2" data-testid="reviews-summary-pill">
              <Stars />
              <span className="font-display font-extrabold text-white text-lg">{BUSINESS.rating}</span>
              <span className="text-slate-400 text-sm">· {BUSINESS.reviewCount} Google reviews</span>
            </span>
            <a href={BUSINESS.reviewUrl} target="_blank" rel="noopener noreferrer" className="btn-gold !py-2 !px-4 !text-sm" data-testid="reviews-leave-review-btn">
              Leave a review
            </a>
          </span>
        }
      />
      <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-8% 0px" }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: EASE }}
            className={`relative bg-panel/80 border border-white/10 rounded-xl p-7 sm:p-9 hover:border-white/20 transition-colors duration-300 ${i === 0 ? "md:-rotate-1" : i === 3 ? "md:rotate-1" : ""}`}
            data-testid={`review-card-${i + 1}`}
          >
            <Quote className="absolute right-7 top-7 text-brand/20" size={40} />
            <Stars />
            <blockquote className="mt-5 text-slate-200 leading-relaxed text-base sm:text-lg">“{r.text}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-4">
              <span className="grid place-items-center w-11 h-11 rounded-full bg-brand text-white font-display font-black text-lg">{r.name[0]}</span>
              <div>
                <div className="font-display font-bold uppercase tracking-wider text-white">{r.name}</div>
                <div className="text-xs text-slate-500">{r.suburb} · {r.service}</div>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-8 text-xs text-slate-500 font-mono uppercase tracking-widest">
        Reviews reflect genuine customer feedback · Names abbreviated for privacy
      </Reveal>
    </div>
  </section>
);
